/**
 * Parse display picture from localStorage (may be JSON-stringified from auth flow).
 */
export function parseStoredDisplayPicture(raw) {
  if (raw == null) return '';
  const s = String(raw).trim();
  if (!s || s === 'undefined') return '';
  try {
    const parsed = JSON.parse(s);
    if (parsed == null || parsed === '') return '';
    return String(parsed).trim();
  } catch {
    return s.replace(/^"|"$/g, '').trim();
  }
}

/** True when user has a real uploaded/assigned image (not null/empty). */
export function hasUploadedProfilePicture(raw) {
  const v = parseStoredDisplayPicture(raw);
  if (!v || v === 'null' || v === 'undefined') return false;
  if (v.startsWith('data:image')) return true;
  if (/^https?:\/\//i.test(v)) return true;
  // Relative upload paths or CDN paths
  if (v.startsWith('/') && v.length > 4) return true;
  return false;
}
